import DataStore from './storedData';
import { serverURL } from '../setPublicPath';

const testNumberToName = ["", "gpr", "srr", "topo", "mmd", "drilling", "analysis", "well", "exca", "sgsa"];

const API_ENDPOINTS = {
    data: serverURL + "history/?cachebuster=" + String(Math.random()),
    info: serverURL + "info/",
    test: serverURL + "test/"
};

const DICT = {
    loadFail: 'could not load data from server'
};

export const error_custom_prefix = 'error_custom';
export const error_retry_prefix = 'error_retry';

function fetchData(url, init = {}) {
  return fetch(url, init).then(result => {
      if (result.ok) {
          return result.text();
      } else {
          return Promise.reject();
      }
  });
}

class Comm {
    constructor() {
        this.syncBuffer = [];
        this.syncQueue = [];

        this.syncQueue.saveData = () => {
            if (this.syncBuffer.length > 0) {
                return;
            }
            if (this.syncQueue.length > 0) {
                this.syncBuffer.push(this.syncQueue.shift());
            }
            if (this.syncBuffer.length === 0) {
                return;
            }
            if (this.syncBuffer[0].infoType) {
                this.saveInfo(this.syncBuffer[0]);
            } else {
                this.saveTest(this.syncBuffer[0]);
            }
        };

        this.commCB_save = (type, error) => {
            if (error) {
                this.openRetryPopup(type);
            } else {
                this.syncBuffer = [];
                if (this.syncQueue.length > 0)
                {
                    this.syncQueue.saveData();
                }
            }
        };

        this.dataStore = new DataStore(this.syncQueue);
    }

    loadData(onFail, onSuccess, openRetryPopup) {
        fetchData(API_ENDPOINTS.data).then(data => {
            if (!data) {
                return Promise.reject(DICT['loadFail']);
            } else if (data.indexOf("error") === 0) {
                return Promise.reject(data);
            }

            let parser = new DOMParser();
            let xmlDoc = parser.parseFromString(data,"text/xml");
            let i;

            const rightType = function(val) { return val.nodeType === Node.ELEMENT_NODE };

            let xmlRoot = xmlDoc.documentElement;
            let childNodes = Array.prototype.filter.call(xmlRoot.childNodes, rightType);

            if(xmlRoot.nodeName !== "bfaxml") {
                if(xmlRoot.nodeName === "error") {
                    return Promise.reject(xmlRoot.firstChild.textContent);
                }
                return Promise.reject("Malformed XML. Expected bfaxml element.");
            }
            let config = childNodes[0];
            if(config.nodeName !== "config") {
                return Promise.reject("Malformed XML. Expected config element as first child of bfaxml element.");
            }
            let configChildren = Array.prototype.filter.call(config.childNodes, rightType);
            let user = configChildren[0];
            if (user.nodeName !== "user") {
                return Promise.reject("Malformed XML. Expected user element as first child of config element.");
            }
            let realname = user.hasAttribute('realname') ? user.getAttribute('realname') : "No Name";

            this.dataStore.setParam('username', realname);
            this.dataStore.setParam('superTestEnabled', false);

            let narrative = configChildren[1];
            let narrativeEnabled = narrative.getAttribute('enabled');
            this.dataStore.setParam('narrativeEnabled', narrativeEnabled === "True");

            let infoDocs = configChildren[2].querySelectorAll('[type="doc"]');
            for (i = 0; i < infoDocs.length; i++) {
                this.dataStore.loadReceivedDocument(infoDocs[i].getAttribute('name'));
            }

            let testData = Array.prototype.filter.call(childNodes[1].childNodes, rightType);
            for (i = 0; i < testData.length; i++) {
                let test = testData[i];
                let x = Number(test.getAttribute("x"));
                let y = Number(test.getAttribute("y"));
                let z = Number(test.getAttribute("z"));
                let name = testNumberToName[test.getAttribute("n")];
                let paramString = test.getAttribute("paramString");
                if (!this.dataStore.loadPerformedTest(name, x, y, z, paramString)) {
                    return Promise.reject("Corrupt XML. A testName was missing.");
                }
            }

            var budgetItems = Array.prototype.filter.call(childNodes[2].childNodes, rightType);
            var balance = 0;
            for (i = budgetItems.length - 1; i >= 0; i--) {
                let a = budgetItems[i].getAttribute('a');
                let d = budgetItems[i].getAttribute('d');
                let dateString = budgetItems[i].getAttribute('t').split(' ');
                let date = dateString[0].split('/');
                let time = dateString[1].split(':');
                this.dataStore.loadBudgetItem(a, new Date(Number(date[0]),Number(date[1]) - 1,Number(date[2]),Number(time[0]),Number(time[1])), d);
                balance += Number(a);
            }

            this.dataStore.loadBalance(balance);
            if (openRetryPopup) this.openRetryPopup = openRetryPopup;

            return true;
        }, () => {
            return Promise.reject(DICT['loadFail']);
        }).then(onSuccess, onFail);
    }

    saveInfo(syncObj) {
        let newData = new FormData();

        newData.append("infoType", syncObj.infoType);
        newData.append("internalName", syncObj.internalName);
        newData.append("cost", syncObj.cost);
        newData.append("date", Comm.dateFormat(syncObj.date));
        newData.append("description", syncObj.description);
        if ('paramString' in syncObj && syncObj.paramString !== null && typeof syncObj.paramString !== 'undefined') {
            newData.append("paramString", syncObj.paramString);
        }
        this.save(newData,API_ENDPOINTS.info,this.commCB_save.bind(this, 'info'));
    }
    saveTest(syncObj) {
        let newData = new FormData();

        newData.append("testNumber", String(testNumberToName.indexOf(syncObj.testName)));
        newData.append("x", String(String(syncObj.x)));
        newData.append("y", String(String(syncObj.y)));
        if ('z' in syncObj && syncObj.z !== null && typeof syncObj.z !== 'undefined') {
            newData.append("z", String(syncObj.z));

        }
        newData.append("cost", syncObj.cost);
        newData.append("date", Comm.dateFormat(syncObj.date));
        newData.append("description", syncObj.description);

        if ('paramString' in syncObj && syncObj.paramString !== null && typeof syncObj.paramString !== 'undefined') {
            newData.append("paramString", syncObj.paramString);
        }
        this.save(newData,API_ENDPOINTS.test,this.commCB_save.bind(this, 'test'));
    }
    save(body, urlSuffix, callback) {
        fetchData(urlSuffix, { method: "POST", body }).then(data => {
            let parser = new DOMParser();
            let xmlDoc = parser.parseFromString(data,"text/xml");

            const rightType = function(val) { return val.nodeType === Node.ELEMENT_NODE };

            let xmlRoot = xmlDoc.documentElement;
            let childNodes = Array.prototype.filter.call(xmlRoot.childNodes, rightType);

            if (childNodes.length && childNodes[0].nodeName === 'response' && childNodes[0].textContent.toLowerCase() === 'ok') {
                callback();

            } else {
                callback("failed to communicate with server");
            }
        }, () => {
            callback("failed to communicate with server");
        });
    }
    static dateFormat(d) {
        let min = String(d.getMinutes());
        if(min.length === 1) {
            min = "0" + min;
        }

        return d.getFullYear() + "/" + (d.getMonth() + 1) + "/" + d.getDate() + " " + d.getHours() + ":" + min;
    }

}

export default new Comm();